var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTwitterBig = function SvgTwitterBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.739 4.112c.014.18.014.361.014.542 0 5.504-4.537 11.846-12.83 11.846-2.554 0-4.927-.683-6.923-1.87.363.04.712.052 1.089.052 2.108 0 4.048-.657 5.598-1.779-1.983-.038-3.644-1.237-4.216-2.887.279.039.558.065.851.065.405 0 .81-.052 1.187-.142C2.443 9.552.893 7.876.893 5.852v-.051c.6.31 1.299.503 2.038.528C1.717 5.582.921 4.305.921 2.862c0-.774.224-1.483.614-2.101 2.22 2.526 5.556 4.176 9.297 4.357a4.354 4.354 0 01-.111-.954C10.72 1.869 12.73 0 15.23 0c1.298 0 2.47.503 3.294 1.315A9.337 9.337 0 0021.386.309c-.335.967-1.047 1.78-1.982 2.295A9.636 9.636 0 0022 1.959a9.323 9.323 0 01-2.261 2.153z",
    fill: "#C4C4C4"
  })));
};
export default SvgTwitterBig;